import { HRMReqApproveForm } from './components/HRMReqApproveForm';
import { ITReqApproveForm } from './components/ITReqApproveForm';
import { ResignationReqApproveForm } from './components/ResignationReqApproveForm';

export const getApproveForm = (requestType: string): JSX.Element => {
  switch (requestType) {
    case 'IT Requisition':
    case 'ITRequisition':
      return <ITReqApproveForm />;
    case 'Resignation Request':
      return <ResignationReqApproveForm />;
    default:
      return <HRMReqApproveForm />;
  }
};
